import { Toast, BodyOutputType } from "angular2-toaster";

export function isPresent(obj: any): boolean {
  return obj !== undefined && obj !== null;
}

export function isDate(obj: any): boolean {
  return !/Invalid|NaN/.test(new Date(obj).toString());
}

export function throwErrorToast(): Toast {
  let toast: Toast = {
    type: 'error',
    title: 'Error has occurred',
    body: 'Oops! Looks like something went wrong with your request. Please try again or contact <a href="mailto:mfgsupport@claytonhomes.com">MFG Support</a> for assistance',
    bodyOutputType: BodyOutputType.TrustedHtml
  }
  return this.toasterService.pop(toast);

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/utilities/lang.ts